import {
    computed,
    watch
} from '@vue/composition-api';

// utils
import { transformToInt } from '@/utils/';

/**
 *
 * Definição das propriedades base das drops.
 *
 * @since 1.0.0
 *
 */
const baseProps = {
    targetClass: String,
    data: Array,
    ordering: Boolean,
    apiValue: Object,
    reset: Boolean
};

/**
 *
 * Comportamento base dos componentes autocomplete e
 * multi-options. Filtragem dos resultados & navegação
 * com as teclas.
 *
 * @since 1.0.0
 * @category Hook
 * @param {Object} props
 * @param {Object} state
 * @returns {Functions}
 *
 */
const behavior = ( props, state ) => {
    // listener de quando informação
    // é actualizada.
    watch( () => props.data,
        newData => {
            state.fields = newData || [];

            // se não houver valor
            // selecionado, não é necessário validar
            // se é preciso actualizar.
            if ( state.model && newData.length ) {
                // obtenção dos valores que estão no array.
                const answer = state.fields.find( field => (
                    field.value === transformToInt( state.value ) || state.model === field.label
                ) );

                // actualização dos valores da drop.
                state.model = answer?.label;
                state.value = answer?.value;

                // se o valor da input não tiver nas opções da drop, limpa a input
                if ( !answer ) {
                    state.model = '';
                    state.value = '';
                }
            }
        });

    // filtragem dos campos
    const filterFields = computed( () => {
        // validação se existe valor inserido pelo
        // utilizador
        if ( !state.model )
            return state.fields;

        const valueLowerCase = state.model.toString().toLowerCase();

        const filter = ({ label }) => label.toLowerCase().includes( valueLowerCase );

        return state.fields.filter( filter );
    });

    const noResults = computed( () => filterFields.value.length === 0 || filterFields.value.every( field => field.hide ) );

    // navageção com as teclas
    const fixScrolling = () => {
        const optionElement = state.parent.querySelector( `[data-id="${state.selectedOption}"]` );

        if ( !optionElement )
            return;

        optionElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };

    const pressArrowDown = () => {
        if ( state.selectedOption < filterFields.value.length - 1 ) {
            state.selectedOption++;
            fixScrolling();
        }
    };

    const pressArrowUp = () => {
        if ( state.selectedOption > 0 ) {
            state.selectedOption--;
            fixScrolling();
        }
    };

    return {
        filterFields,
        noResults,
        pressArrowDown,
        pressArrowUp
    };
};

export {
    baseProps,
    behavior
};